import { InfoOutlined } from "@mui/icons-material";
import { IconButton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { LineChart } from "@mui/x-charts";
import { useApiTrigger } from "../../hooks/useApiTrigger";

const parseDynamicLineData = (rawData) => {
    if (!rawData || rawData.length === 0) {
        return { categories: [], dataValues: [] };
    }

    const categories = rawData.map(item => item.category);
    const seriesKeys = Object.keys(rawData[0]).filter(
        key => key !== 'category' && key !== 'configuration'
    );

    const dataValues = seriesKeys.map(key => ({
        label: key,
        data: rawData.map(item => item[key] || 0),
        valueFormatter: (value) => value.toLocaleString('es-CO'),
        showMark: true,
    }));

    return {
        categories,
        dataValues
    };
};

const SimpleLineChart = ({ data, filters }) => {
    const { dto: dtoChart } = useApiTrigger(data, filters);
    const dto = parseDynamicLineData(dtoChart);

    return (
        <Box
            sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', p: 1 }}
        >
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ height: 36, flexShrink: 0 }}>
                <Typography fontWeight={500} noWrap>
                    {dto.title}
                </Typography>
                {/* <IconButton size="small">
                    <InfoOutlined sx={{ fontSize: 16 }} />
                </IconButton> */}
            </Box>

            <LineChart
                xAxis={[{
                    scaleType: 'point',
                    data: dto.categories
                }]}
                series={dto.dataValues}
                sx={{
                    '.MuiLineElement-root': { strokeWidth: 3 },
                    '.MuiAreaElement-root': { fillOpacity: 0.2 },
                    '& .MuiChartsGrid-line': {
                        strokeDasharray: '5 5',
                        stroke: '#E0E0E0',
                    },
                }}
                grid={{ vertical: false, horizontal: true }}
                margin={{ left: 0, right: 1, top: 1, bottom: 3 }}
            />
        </Box>
    );
}

export default SimpleLineChart;